var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5C11 12.2239 11.1865 12 11.4167 12H20.5833C20.8135 12 21 12.2239 21 12.5C21 12.7761 20.8135 13 20.5833 13H11.4167C11.1865 13 11 12.7761 11 12.5Z",
    fill: "#001024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5C15 18.2239 15.1865 18 15.4167 18H16.5833C16.8135 18 17 18.2239 17 18.5C17 18.7761 16.8135 19 16.5833 19H15.4167C15.1865 19 15 18.7761 15 18.5Z",
    fill: "#001024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5C13 15.2239 13.1865 15 13.4167 15H18.5833C18.8135 15 19 15.2239 19 15.5C19 15.7761 18.8135 16 18.5833 16H13.4167C13.1865 16 13 15.7761 13 15.5Z",
    fill: "#001024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5044afe617ce20e53f0b57ade56dcbd2.svg";
export { ForwardRef as ReactComponent };